import React, { useEffect, useState, useCallback } from "react";
import { useLocation } from "react-router-dom";
import Summarization from "./Summarization";
import useAppDispatch from "hooks/useAppDispatch";
import { reset } from "features/pictureSearch/pictureSearchSlice";

const PictureSummarizationPage: React.FC = () => {
  const [startDate, setStartDate] = useState<string>("");
  const [endDate, setEndDate] = useState<string>("");
  const location = useLocation();
  const dispatch = useAppDispatch();
  const resetSearchFilter = useCallback(() => {
    dispatch(reset());
  }, [dispatch]);

  useEffect(() => {
    document.addEventListener("back", resetSearchFilter);

    return () => {
      document.removeEventListener("back", resetSearchFilter);
    };
  }, [resetSearchFilter]);

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const startDateParam = urlParams.get("startDate");
    const endDateParam = urlParams.get("endDate");

    if (startDateParam) {
      const startDate = new Date(startDateParam);
      startDate.setUTCHours(0, 0, 0, 0);
      setStartDate(startDate.toISOString());
    }

    if (endDateParam) {
      const endDate = new Date(endDateParam);
      endDate.setUTCHours(23, 59, 59, 999);
      setEndDate(endDate.toISOString());
    }
  }, [location.search]);

  return (
    <section className="h-full flex flex-col space-y-3 lg:space-y-5">
      <div className="flex-1">
        <Summarization startDate={startDate} endDate={endDate} />
      </div>
    </section>
  );
};

export default PictureSummarizationPage;
